module.exports = __webpack_public_path__ + "static/media/oval-capital-regulation.91930ab9.png";